import { useTranslation } from 'react-i18next';
import { MdLanguage } from 'react-icons/md';
import CustomSelect from '@/components/common/CustomSelect';
import { SUPPORTED_LANGUAGES } from '@/i18n/languages';
import { cn } from '@/lib/utils';

interface LanguageSwitcherProps {
  className?: string;
  triggerClassName?: string;
}

const languageOptions = SUPPORTED_LANGUAGES.map((language) => ({
  label: language.nativeLabel,
  value: language.code,
}));

const LanguageSwitcher = ({ className, triggerClassName }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();

  const handleChange = (code: string) => {
    i18n.changeLanguage(code);
  };

  return (
    <div className={cn('flex items-center gap-1', className)}>
      <MdLanguage size={16} className="shrink-0" />
      <CustomSelect
        options={languageOptions}
        value={i18n.resolvedLanguage ?? i18n.language}
        onChange={handleChange}
        className={cn('w-[76px] h-7 px-2 py-1 text-[11px]', triggerClassName)}
      />
    </div>
  );
};

export default LanguageSwitcher;
